import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { ChevronLeft, ChevronRight, Link } from 'react-feather'
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore'
import { db } from '../../lib/firbase'
import './Feedback.css'

export default function Feedback() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [testimonials, setTestimonials] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const q = query(
      collection(db, 'feedback'),
      orderBy('timestamp', 'desc')
    )

    const unsubscribe = onSnapshot(q, (snapshot) => {
      try {
        const feedbackData = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          timestamp: doc.data().timestamp?.toDate()
        }))
        setTestimonials(feedbackData)
        setError(null)
      } catch (err) {
        console.error('Error processing feedback:', err)
        setError('Unable to load testimonials at this time')
      } finally {
        setIsLoading(false)
      }
    }, (err) => {
      console.error('Error fetching feedback:', err)
      setError('Unable to load testimonials at this time')
      setIsLoading(false)
    })

    return () => unsubscribe()
  }, [])

  useEffect(() => {
    if (testimonials.length === 0) return

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      )
    }, 5000)

    return () => clearInterval(interval)
  }, [testimonials.length])

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    )
  }

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    )
  }

  return (
    <section className="feedback-section">
      <div className="feedback-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="feedback-header"
        >
          <h2>Customer <span className="gradient-text">Feedback</span></h2>
          <p>What our clients say about us</p>
        </motion.div>

        <div className="testimonials-container">
          {isLoading ? (
            <div className="loading-state">Loading testimonials...</div>
          ) : error ? (
            <div className="error-state">{error}</div>
          ) : testimonials.length > 0 ? (
            <>
              <button 
                className="nav-button prev"
                onClick={prevTestimonial}
                aria-label="Previous testimonial"
              >
                <ChevronLeft />
              </button>

              <div className="testimonials-wrapper">
                {testimonials.map((testimonial, index) => (
                  <motion.div
                    key={testimonial.id}
                    className={`testimonial-card ${index === currentIndex ? 'active' : ''}`}
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ 
                      opacity: index === currentIndex ? 1 : 0,
                      x: index === currentIndex ? 0 : 100
                    }}
                    transition={{ duration: 0.5 }}
                  >
                    <p className="testimonial-text">{testimonial.feedback}</p>
                    <div className="testimonial-author">
                      <strong>{testimonial.name}</strong>
                      {testimonial.company && <span>{testimonial.company}</span>}
                    </div>
                  </motion.div>
                ))}
              </div>

              <button 
                className="nav-button next"
                onClick={nextTestimonial}
                aria-label="Next testimonial"
              >
                <ChevronRight />
              </button>
            </>
          ) : (
            <div className="empty-state">No testimonials available</div>
          )}
        </div>

        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="feedback-link-container"
        >
          <h3>Share Your Experience</h3>
          <p>We value your feedback! Click below to share your experience with Ignix Solutions.</p>
          <Link to="/submit-feedback" className="feedback-button">
            Submit Feedback
            <Link className="button-icon" />
          </Link>
        </motion.div> */}
      </div>
    </section>
  )
}

